export default __webpack_public_path__ + "static/media/white-csv.5f1b9ac0.svg";